import {
  AuditItemState,
  getAuditItemStateColor
} from '@cdab/scania/qpr/components/atoms'
import { getIconSize } from '@cdab/utils'

import { TdsIcon } from '@scania/tegel-react'
import styled from 'styled-components'

export interface InfoIconProps {
  state: AuditItemState
}

export const StyledIconInfo = styled(TdsIcon)<InfoIconProps>`
  color: ${({ state }) =>
    state === AuditItemState.NotComplete
      ? 'var(--tds-black)'
      : getAuditItemStateColor(state)};
`

export const StarIcon = styled(TdsIcon)`
  color: var(--tds-black);
`

export const ExtrasRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: var(--tds-spacing-element-8);
  row-gap: var(--tds-spacing-element-4);
  margin-top: var(--tds-spacing-element-4);
`

export const Extra = styled.div.attrs({
  className: 'tds-detail-05'
})`
  display: flex;
  align-items: flex-end;

  tds-icon {
    width: ${getIconSize('small')};
    height: ${getIconSize('small')};
  }
`

export const BlackIcon = styled(TdsIcon)`
  color: var(--tds-black) !important;
`

export const AuditItemContent = styled.div`
  display: flex;
  flex-direction: column;
`
